import { isNil } from 'es-toolkit';
import { useTranslation } from 'next-i18next';

import type { CategoryGroupInfoDto } from '@/api/gen/_model/categoryGroupInfoDto';
import { type CommonTranslationKeys } from '@/types/translation';
import { isAllGrades } from '@/views/build/util';

import { SchoolMapper } from '../category/util';

export const useSchoolInfoShortTranslation = ({
  schoolInfo,
}: {
  schoolInfo: Omit<CategoryGroupInfoDto, 'subject' | 'subSubject'>;
}) => {
  const { t } = useTranslation(['common']);

  const { schoolType, schoolSemester, schoolGrade } = schoolInfo ?? {
    schoolType: undefined,
    schoolSemester: undefined,
    schoolGrade: undefined,
  };

  const translatedSchoolType = !isNil(schoolType)
    ? t(
        `common:school.levelShort.${SchoolMapper.getSchoolTypeNameById(
          Number(schoolType),
        )}` as CommonTranslationKeys,
      )
    : null;

  const gradeNumber = schoolGrade ? parseInt(schoolGrade, 10) : 0;
  const allGrades = isAllGrades(gradeNumber);

  // 전학년이면 학기 숨김
  const translatedSchoolSemester =
    !allGrades && schoolSemester
      ? SchoolMapper.isEtc(Number(schoolSemester))
        ? t('school.info.shared')
        : `${schoolSemester}`
      : null;

  // 0, 01 다 숫자로 치환후 문자변환
  // 전학년이면 "전학년" 표시
  const translatedSchoolGrade =
    schoolGrade && Number(schoolGrade) !== 0
      ? allGrades
        ? String(t('school.info.allGrades'))
        : gradeNumber.toString()
      : '';

  return {
    schoolTypeText: translatedSchoolType,
    schoolSemesterText: translatedSchoolSemester,
    schoolGradeText: translatedSchoolGrade,
  };
};
